exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col {\n  background-color: #e73d50;\n  color: white;\n  min-height: 100vh;\n}\n\n.content {\n  margin: auto;\n}\n\nh2 {\n  margin-bottom: .6rem;\n  font-size: 1.3rem;\n  margin-top: -.5rem;\n}\n\nh1 {\n  margin-top: .5rem;\n}\n\n.vertical-center {\n  height: 100vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/speaking/speaking.component.css
// module id = ../../../../../src/app/speaking/speaking.component.css
// module chunks = main